import { Injectable, signal, effect } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly STORAGE_KEY = 'dark-mode';

  /**
   * Signal réactif d'état sombre
   */
  readonly isDark = signal<boolean>(this.getInitialTheme());

  constructor() {
    // Appliquer le thème dès l'initialisation et à chaque changement de signal
    effect(() => {
      const dark = this.isDark();
      this.applyTheme(dark);
    });
  }



  /**
   * Basculer entre clair et sombre
   */
  public toggle(): void {
    this.isDark.update((v) => !v);
  }

  /**
   * Forcer le mode sombre
   */
  public enableDark(): void {
    this.isDark.set(true);
  }

  /**
   * Forcer le mode clair
   */
  public enableLight(): void {
    this.isDark.set(false);
  }

  private getInitialTheme(): boolean {
    if (typeof window === 'undefined') return false;
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (stored !== null) {
      return stored === 'true';
    }
    // Mode clair par défaut
    return false;
  }

  private applyTheme(isDark: boolean): void {
    if (typeof document === 'undefined') return;
    const root = document.documentElement;

    // Tailwind CSS utilise 'dark', PrimeNG Aura utilise 'app-dark'
    root.classList.toggle('dark', isDark);
    root.classList.toggle('app-dark', isDark);

    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(this.STORAGE_KEY, String(isDark));
    }
  }
}
